export class DeltaDate {
  static getTimeLeft(fromDate: Date, toDate: Date): string {
    let msec = toDate.valueOf() - fromDate.valueOf();
    let sign = msec < 0 ? '-' : '';

    if (msec < 0) {
      return '';
    }

    var mins = Math.floor(msec / 60000);
    var hrs = Math.floor(mins / 60);
    var days = Math.floor(hrs / 24);

    mins = mins % 60;
    hrs = hrs % 24;
    days = days % 365;

    let daysStr = Math.abs(days) !== 0 ? Math.abs(days) + ' д ' : '';
    let hrsStr = Math.abs(hrs) !== 0 ? Math.abs(hrs) + ' ч ' : '';
    let minsStr = Math.abs(mins) !== 0 ? Math.abs(mins) + ' м' : '';

    return `${sign}${daysStr}${hrsStr}${minsStr}`;
  }

  static getTimeLeftByTimeSec(timeSec: number): string {
    let sign = timeSec < 0 ? '-' : '';

    /*if(timeSec < 0) {
            return "";
        }*/

    var mins = Math.floor(timeSec / 60);
    var hrs = Math.floor(mins / 60);
    var days = Math.floor(hrs / 24);

    mins = mins % 60;
    hrs = hrs % 24;
    days = days % 365;

    let daysStr = Math.abs(days) !== 0 ? Math.abs(days) + ' д ' : '';
    let hrsStr = Math.abs(hrs) !== 0 ? Math.abs(hrs) + ' ч ' : '';
    let minsStr = Math.abs(mins) !== 0 || hrsStr != '' ? Math.abs(mins) + ' м' : '';

    return `${sign}${daysStr}${hrsStr}${minsStr}`;
  }
}
